export let displayName = () => {

  if ( localStorage.displayName === undefined ) {
    return "";
  } else {
    return localStorage.displayName;
  }

}
